import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {  BehaviorSubject, Observable, map } from 'rxjs';
import { Roster } from '../models/Roster/roster.model';
import { environment } from 'src/environments/environment';
import { SchoolCampus } from '../models/school.model';
import { AccessRequest } from '../models/Requests/AccessRequest.model';
import { RosterBasicData } from '../models/Roster/rosterBasicData.model';
import { StudentExistRequest, UploadRosterRequest } from '../models/Requests/RosterDataRequest.model';
import { SubmittedRosterRequest } from '../models/Requests/SubmittedRosterRequest.model';
import { SaveRosterRequest } from '../models/Requests/SaveRosterRequest.model';
import { SaveRosterStudents } from '../models/Roster/SaveRosterStudents.model';
import { RosterStudent } from '../models/Roster/RosterStudent.model';

@Injectable({
  providedIn: 'root'
})

export class RostersService {
  apiUrl: string = "Roster";
  deleteRosterUrl: string = '/DeleteRoster';

  constructor(private http: HttpClient) {

  }
  draftRosterTab = new BehaviorSubject<string>("");
  isDuplicateStudId = new BehaviorSubject<string>("");
  check = this.isDuplicateStudId.asObservable();
  getDraftRosters(accessID: number,accessLevel: number, userId: string): Observable<Roster[]> {
    let args = {
      accessID : accessID,
      accessLevel: accessLevel,
      userId: userId
    };
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(args);
    return this.http.post<Roster[]>(environment.baseUrl + this.apiUrl + '/draftRosters',
      body, { headers: headers })
  }

  deleteRoster(rosterID: number): Observable<any> {

    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(rosterID);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/DeleteRoster', body, { headers: headers });
  }

  getSubmittedRosters(userId:string,accessID: number, accessLevel: number): Observable<any> {
    let args = {
      userId: userId,
      accessId: accessID,
      accessLevel: accessLevel
    };
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(args);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/SubmittedRosters', body, { headers: headers }).pipe(map(data => {
      return data.body;
    }));
  }

  getPreviousYearRosters(userId:string,accessID: number, accessLevel: number): Observable<any> {
    let args = {
      userId: userId,
      accessId: accessID,
      accessLevel: accessLevel
    };
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(args);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/SubmittedRostersPreviousYear', body, { headers: headers }).pipe(map(data => {
      return data.body;
    }));
  }

  getCoverages(request: SubmittedRosterRequest): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(request);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/CoverageDetailsForRoster', body, { headers: headers }).pipe(map(data => {
      return data.body;
    }));
  }

  getCoveredStudents(rosterNo: number): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(rosterNo);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/CoveredStudentsForRoster', body, { headers: headers }).pipe(map(data => {
      return data.body;
    }))
  }
  getCampusList(req:AccessRequest): Observable<SchoolCampus[]>{
    return this.http.post<SchoolCampus[]>(environment.baseUrl+this.apiUrl+'/Campus', req);
  }
  getActivityListByCampus(): Observable<string[]>{
    return this.http.post<string[]>(environment.baseUrl+this.apiUrl+'/ActivityByCampus', null);
  }
  getRosterDataByCampusActivity(activity: string): Observable<RosterBasicData[]>{
    const headers = { 'content-type': 'application/json'}
    const body= JSON.stringify(activity);
    return this.http.post<RosterBasicData[]>(environment.baseUrl+this.apiUrl+'/NewRosterBasicData', body, {headers: headers});
  }
  checkIfStudentExists(req: StudentExistRequest): Observable<number>{
    const headers = { 'content-type': 'application/json'}
    const body= JSON.stringify(req);
    return this.http.post<number>(environment.baseUrl+this.apiUrl+'/DuplicateStudIdCheck', body, {headers: headers});
  }
  SaveRoster(req: SaveRosterRequest): Observable<number>{
    const headers = { 'content-type': 'application/json'}
    const body= JSON.stringify(req);
    return this.http.post<number>(environment.baseUrl+this.apiUrl+'/SaveRoster', body, {headers: headers});
  }
  getEditRosterData(rosterNo:number):Observable<Roster>{
    const headers = {'content-type':'application/json'}
    const body = JSON.stringify(rosterNo);
    return this.http.post<Roster>(environment.baseUrl + this.apiUrl+'/EditRosterData',
    body,{headers:headers})
  }
  getRosterStudents(rosterNo:number):Observable<SaveRosterStudents>{
    const headers = {'content-type':'application/json'}
    const body = JSON.stringify(rosterNo);
    return this.http.post<SaveRosterStudents>(environment.baseUrl + this.apiUrl+'/LoadRosterStudents',
    body,{headers:headers})
  }
  ValidateUploadRosterData(req: UploadRosterRequest): Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body= JSON.stringify(req);
    return this.http.post<any>(environment.baseUrl+this.apiUrl+'/CheckUploadRoster', body, {headers: headers});
  }

  getRosterBankDepositDates(rosterNos: number[]): Observable<any>{
    const headers = { 'content-type': 'application/json'}
    const body= JSON.stringify(rosterNos);
    return this.http.post<any>(environment.baseUrl+this.apiUrl+'/BankDepositDates', body, {headers: headers});
  }
}
